//  Copyright (c) 2008 David Caldwell,  All Rights Reserved.

// Abstract away Sirtet keyboard focusing / pause stuff so other games can use it.

var lib = require('./lib');
var dom = require('./dom'), doc=dom.doc;
var plat = require('./platform');

function KeyboardFocusAutoPauseMixin(Base) {
    return class extends Base {
        init_keyboard_focus_auto_pause(game_div, pause_button_div) {
            this._pause_button_div = pause_button_div;
            this._input_div = doc.el("input", { id:"input", style: { width:"0px", height:"0px", position:"relative", left:"-10000px" } });
            this._input_div.onblur = () => this.pause(1);
            game_div.parentNode.appendChild(this._input_div);

            // pause_hack prevents this: Focus on input -> click pause -> unfocus event -> pause(1) -> onclick event -> pause() (toggle)
            if (pause_button_div) pause_button_div.onmousedown = () => { if (this._pause_hack = (this.is_pausable() && !this.paused)) { this._key_pause = 0; this.pause(1); return false; } };
            if (pause_button_div) pause_button_div.onmouseup = () => { if (!this._pause_hack) { this._key_pause = 0; this.pause(); } };
            game_div.onclick = () => { this._input_div.focus(); if (this.paused && !this._key_pause) this.pause(0) };
            window.addEventListener('blur', () => this.window_blurred = true);
            window.addEventListener('focus', () => delete this.window_blurred);
        }
        key_pause(pause) {
            this.pause(pause);
            if (this.paused) this._key_pause = true;
        }
        is_pausable() {
            return this.pausable ? this.pausable() : true;
        };
        pause(pause) {
            if (pause != undefined && !((this.paused ? 1 : 0) ^ pause))
                return;
            if (pause && !this.is_pausable())
                return;
            if (!this.paused) {
                this.paused = true;
                if (this._pause_button_div) this._pause_button_div.value = this._pause_button_div.value.replace(/Pause/, "Unpause");
                if (this.stats) this.stats.pause();
                if (this.on_pause) this.on_pause();
            } else {
                this.paused = false;
                this._input_div.focus();
                if (this._pause_button_div) this._pause_button_div.value = this._pause_button_div.value.replace(/Unpause/, "Pause");
                if (this.stats) this.stats.unpause();
                if (this.on_unpause) this.on_unpause();
            }
        }

        register_key_events(handler) {
            var args = Array.prototype.slice.call(arguments);
            args[0] = args[0].bind(this);
            args.unshift(this._input_div);
            plat.register_key_events.apply(null,args);
            //PlatformSpecific.prototype.register_key_events.call(args);
        }

        input_focus() {
            this._input_div.focus();
            this.pause(false);
        }
    }
}

class KeyboardFocusAutoPause extends KeyboardFocusAutoPauseMixin(Object) {}
KeyboardFocusAutoPause.mixin = KeyboardFocusAutoPauseMixin;

module.exports = KeyboardFocusAutoPause;
//  Copyright (c) 2008 David Caldwell,  All Rights Reserved.

// Abstract away Sirtet keyboard focusing / pause stuff so other games can use it.

var lib = require('./lib');
var dom = require('./dom'), doc=dom.doc;
var plat = require('./platform');

function KeyboardFocusAutoPauseMixin(Base) {
    return class extends Base {
        init_keyboard_focus_auto_pause(game_div, pause_button_div) {
            this._pause_button_div = pause_button_div;
            this._input_div = doc.el("input", { id:"input", style: { width:"0px", height:"0px", position:"relative", left:"-10000px" } });
            this._input_div.onblur = () => this.pause(1);
            game_div.parentNode.appendChild(this._input_div);

            // pause_hack prevents this: Focus on input -> click pause -> unfocus event -> pause(1) -> onclick event -> pause() (toggle)
            if (pause_button_div) pause_button_div.onmousedown = () => { if (this._pause_hack = (this.is_pausable() && !this.paused)) { this._key_pause = 0; this.pause(1); return false; } };
            if (pause_button_div) pause_button_div.onmouseup = () => { if (!this._pause_hack) { this._key_pause = 0; this.pause(); } };
            game_div.onclick = () => { this._input_div.focus(); if (this.paused && !this._key_pause) this.pause(0) };
            window.addEventListener('blur', () => this.window_blurred = true);
            window.addEventListener('focus', () => delete this.window_blurred);
        }
        key_pause(pause) {
            this.pause(pause);
            if (this.paused) this._key_pause = true;
        }
        is_pausable() {
            return this.pausable ? this.pausable() : true;
        };
        pause(pause) {
            if (pause != undefined && !((this.paused ? 1 : 0) ^ pause))
                return;
            if (pause && !this.is_pausable())
                return;
            if (!this.paused) {
                this.paused = true;
                if (this._pause_button_div) this._pause_button_div.value = this._pause_button_div.value.replace(/Pause/, "Unpause");
                if (this.stats) this.stats.pause();
                if (this.on_pause) this.on_pause();
            } else {
                this.paused = false;
                this._input_div.focus();
                if (this._pause_button_div) this._pause_button_div.value = this._pause_button_div.value.replace(/Unpause/, "Pause");
                if (this.stats) this.stats.unpause();
                if (this.on_unpause) this.on_unpause();
            }
        }

        register_key_events(handler) {
            var args = Array.prototype.slice.call(arguments);
            args[0] = args[0].bind(this);
            args.unshift(this._input_div);
            plat.register_key_events.apply(null,args);
            //PlatformSpecific.prototype.register_key_events.call(args);
        }

        input_focus() {
            this._input_div.focus();
            this.pause(false);
        }
    }
}

class KeyboardFocusAutoPause extends KeyboardFocusAutoPauseMixin(Object) {}
KeyboardFocusAutoPause.mixin = KeyboardFocusAutoPauseMixin;

module.exports = KeyboardFocusAutoPause;
